export default __webpack_public_path__ + "static/media/wave-side.a07e9782.svg";